import { getGrowthBookConfigLoader } from '@doxyme/config';

/**
 * localStorage key to override GraphQL room queries for local testing.
 * Set to 'true' in browser console: localStorage.setItem('doxyme_use_graphql_room_queries', 'true')
 * Remove override: localStorage.removeItem('doxyme_use_graphql_room_queries')
 */
const LOCAL_STORAGE_KEY = 'doxyme_use_graphql_room_queries';

const getLocalStorageOverride = (): boolean | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const value = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
};

export const getIsGraphqlRoomQueriesEnabled = (): boolean => {
  // Check localStorage override first (for local testing)
  const localOverride = getLocalStorageOverride();
  if (localOverride !== null) {
    return localOverride;
  }

  // Fall back to feature flag
  return (
    getGrowthBookConfigLoader().getOptional(
      'feat_prod_2967_graphql_rooms_queries',
    ) === true
  );
};
